import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dhw3mqf63g: FaireBrandEntity = {
  token: "b_dhw3mqf63g",
  type: "brand",
  name: "Big Fork",
  avatarUrl:
    "https://cdn.faire.com/fastly/8aee860940c507a35d87bd4d48781e916a52b9517c3eed5b5f039e003e8fdfef.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fe0d75f0e831983474835eb96c6a9d5e2ba1473c9ac3a2803a36666188c8f17d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8aee860940c507a35d87bd4d48781e916a52b9517c3eed5b5f039e003e8fdfef.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fe0d75f0e831983474835eb96c6a9d5e2ba1473c9ac3a2803a36666188c8f17d.png",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 14,
  isInsider: true,
  description:
    "Big Fork Brands | Bold Chicago Flavor\n\nBig Fork Brands is a Chicago-based, family-owned food company creating clean-label sauces and premium pork snacks for modern kitchens and everyday snacking—with a little Chicago kitch built in.\n\nSauces (Hero)\n\nThe Original Chicago Sauce – 7 toppings of a Chicago hot dog united under one lid (mustard on steroids)\n\nChicago Fire Sauce – Spicy Chicago Sauce made with iconic sport peppers\n\nChicago Fry Sauce – Chicago Sauce blended with mayo & ketchup\n\nGangster Sauce – Chicago Sauce, giardiniera, mayo & extra virgin olive oil infused with black & white truffles\n\nVersatile, shelf-simplifying condiments with hundreds of uses across burgers, fries, eggs, vegetables, marinades, dips, and dressings.\n\nSnacks\n\nMeat sticks, pork jerky & fully cooked bacon sausage\n\nMade from heritage hogs raised outdoors by small family farmers in Iowa\n\nNo antibiotics, clean ingredients, bold flavor\n\nProtein-forward snacks for grab-and-go, gifting, and food sets\n\nWhy Retailers Love It\n\nClear hero sauce + familiar snack formats\n\nStrong Chicago story customers remember\n\nBroad usage drives trial and repeat\n\nClean label. Big flavor. Chicago attitude.\nTurning ordinary food into the extraordinary.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:32.861Z",
    importedBy: "entity-db-cli",
  },
};
